import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'

const Fallback = ({ onRetry }) => {
  const { t_ } = useSmartTranslation()
  return (
    <Box data-testid='block-error'>
      <Typography>{t_('Could not load this block')}</Typography>
      <Button onClick={onRetry}>{t_('Retry')}</Button>
    </Box>
  )
}

// The content box of the detail dialog. A render error inside one block must not blank the whole
// dialog: it shows "Could not load this block" and a Retry. The caller gives it a `key` (block +
// order) so a new block or a jump to another order starts clean; Retry clears the error and mounts
// the children again. It renders the box itself so the blocks keep their place in the caller's JSX.
class DetailErrorBoundary extends React.Component {
  state = { failed: false }

  static getDerivedStateFromError () {
    return { failed: true }
  }

  render () {
    return (
      <Box data-testid='block-content' sx={this.props.sx}>
        {this.state.failed ? <Fallback onRetry={() => this.setState({ failed: false })} /> : this.props.children}
      </Box>
    )
  }
}

export default DetailErrorBoundary
